export interface LiDUi {
  heroTitle: string;
  language: string;
  state: string;
  original: string;
  verified: string;
  translation: string;
  unavailable: string;
  questions: string;
  learn: string;
  exam: string;
  mistakes: string;
  favorites: string;
  progress: string;
  settings: string;
  close: string;
  start: string;
  attempted: string;
  correct: string;
  incorrect: string;
  accuracy: string;
  general: string;
  totalAnswers: string;
  question: string;
  answers: string;
  saveFavorite: string;
  removeFavorite: string;
  pending: string;
  completed: string;
  result: string;
  back: string;
  finish: string;
  next: string;
  directFeedback: string;
}


const KEYS = [
  'heroTitle',
  'language',
  'state',
  'original',
  'verified',
  'translation',
  'unavailable',
  'questions',
  'learn',
  'exam',
  'mistakes',
  'favorites',
  'progress',
  'settings',
  'close',
  'start',
  'attempted',
  'correct',
  'incorrect',
  'accuracy',
  'general',
  'totalAnswers',
  'question',
  'answers',
  'saveFavorite',
  'removeFavorite',
  'pending',
  'completed',
  'result',
  'back',
  'finish',
  'next',
  'directFeedback',
] as const;


const RAW: Record<string, string> = {
  de: 'Lernen. Verstehen. Bestehen.|Sprache|Bundesland|Original|geprüft|Übersetzung|nicht verfügbar|Fragen|Lernen|Prüfung|Fehler|Favoriten|Fortschritt|Einstellungen|Schließen|Starten|Bearbeitet|Richtig|Falsch|Trefferquote|Allgemein|Antworten insgesamt|Frage|Antworten|Als Favorit speichern|Favorit entfernen|Prüfung ausstehend|Abgeschlossen|Ergebnis|Zurück|Prüfung beenden|Weiter|Direktes Feedback',
  tr: 'Öğren. Anla. Başar.|Dil|Eyalet|Orijinal|doğrulandı|Çeviri|mevcut değil|Sorular|Öğrenme|Sınav|Hatalar|Favoriler|İlerleme|Ayarlar|Kapat|Başlat|Çalışılan|Doğru|Yanlış|Başarı oranı|Genel|Toplam cevap|Soru|Cevaplar|Favorilere kaydet|Favorilerden kaldır|İnceleme bekliyor|Tamamlandı|Sonuç|Geri|Sınavı bitir|İleri|Anında geri bildirim',
  en: 'Learn. Understand. Pass.|Language|Federal state|Original|verified|Translation|unavailable|Questions|Learning|Exam|Mistakes|Favorites|Progress|Settings|Close|Start|Attempted|Correct|Incorrect|Accuracy|General|Total answers|Question|Answers|Save as favorite|Remove favorite|Pending review|Completed|Result|Back|Finish exam|Next|Direct feedback',
  ar: 'تعلّم. افهم. انجح.|اللغة|الولاية|الأصل|تم التحقق|الترجمة|غير متاح|الأسئلة|التعلّم|الاختبار|الأخطاء|المفضلة|التقدم|الإعدادات|إغلاق|ابدأ|تمت المعالجة|صحيح|خطأ|نسبة النجاح|عام|إجمالي الإجابات|السؤال|الإجابات|حفظ في المفضلة|إزالة من المفضلة|قيد المراجعة|مكتمل|النتيجة|رجوع|إنهاء الاختبار|التالي|تغذية راجعة فورية',
  pl: 'Ucz się. Zrozum. Zdaj.|Język|Kraj związkowy|Oryginał|sprawdzone|Tłumaczenie|niedostępne|Pytania|Nauka|Egzamin|Błędy|Ulubione|Postęp|Ustawienia|Zamknij|Rozpocznij|Przerobione|Poprawne|Błędne|Skuteczność|Ogólne|Łącznie odpowiedzi|Pytanie|Odpowiedzi|Dodaj do ulubionych|Usuń z ulubionych|W trakcie weryfikacji|Zakończono|Wynik|Wstecz|Zakończ egzamin|Dalej|Natychmiastowa informacja zwrotna',
  uk: 'Навчайся. Розумій. Складай.|Мова|Федеральна земля|Оригінал|перевірено|Переклад|недоступно|Запитання|Навчання|Іспит|Помилки|Обране|Прогрес|Налаштування|Закрити|Почати|Опрацьовано|Правильно|Неправильно|Точність|Загальні|Усього відповідей|Запитання|Відповіді|Додати в обране|Видалити з обраного|Очікує перевірки|Завершено|Результат|Назад|Завершити іспит|Далі|Миттєвий відгук',
  ru: 'Учись. Понимай. Сдавай.|Язык|Федеральная земля|Оригинал|проверено|Перевод|недоступно|Вопросы|Обучение|Экзамен|Ошибки|Избранное|Прогресс|Настройки|Закрыть|Начать|Пройдено|Правильно|Неправильно|Точность|Общие|Всего ответов|Вопрос|Ответы|Добавить в избранное|Удалить из избранного|Ожидает проверки|Завершено|Результат|Назад|Завершить экзамен|Далее|Мгновенная обратная связь',
  sq: 'Mëso. Kupto. Kalo.|Gjuha|Land federal|Origjinali|verifikuar|Përkthimi|i padisponueshëm|Pyetje|Mësim|Provimi|Gabime|Të preferuarat|Përparimi|Cilësimet|Mbyll|Fillo|Të përpunuara|Saktë|Gabim|Saktësia|Të përgjithshme|Përgjigje gjithsej|Pyetja|Përgjigjet|Ruaj te të preferuarat|Hiq nga të preferuarat|Në pritje të verifikimit|Përfunduar|Rezultati|Prapa|Përfundo provimin|Tjetër|Reagim i menjëhershëm',
  es: 'Aprende. Comprende. Aprueba.|Idioma|Estado federado|Original|verificado|Traducción|no disponible|Preguntas|Aprendizaje|Examen|Errores|Favoritos|Progreso|Ajustes|Cerrar|Iniciar|Realizadas|Correcto|Incorrecto|Aciertos|General|Respuestas totales|Pregunta|Respuestas|Guardar en favoritos|Quitar de favoritos|Pendiente de revisión|Completado|Resultado|Atrás|Finalizar examen|Siguiente|Respuesta inmediata',
  fa: 'یاد بگیر. درک کن. قبول شو.|زبان|ایالت فدرال|اصل|تأییدشده|ترجمه|در دسترس نیست|پرسش‌ها|یادگیری|آزمون|اشتباه‌ها|علاقه‌مندی‌ها|پیشرفت|تنظیمات|بستن|شروع|انجام‌شده|درست|نادرست|درصد موفقیت|عمومی|کل پاسخ‌ها|پرسش|پاسخ‌ها|ذخیره در علاقه‌مندی‌ها|حذف از علاقه‌مندی‌ها|در انتظار بررسی|تکمیل‌شده|نتیجه|بازگشت|پایان آزمون|بعدی|بازخورد فوری',
  id: 'Belajar. Pahami. Lulus.|Bahasa|Negara bagian|Asli|terverifikasi|Terjemahan|tidak tersedia|Pertanyaan|Belajar|Ujian|Kesalahan|Favorit|Kemajuan|Pengaturan|Tutup|Mulai|Dikerjakan|Benar|Salah|Akurasi|Umum|Total jawaban|Pertanyaan|Jawaban|Simpan sebagai favorit|Hapus dari favorit|Menunggu pemeriksaan|Selesai|Hasil|Kembali|Akhiri ujian|Berikutnya|Umpan balik langsung',
  fr: 'Apprendre. Comprendre. Réussir.|Langue|Land|Original|vérifié|Traduction|indisponible|Questions|Apprentissage|Examen|Erreurs|Favoris|Progression|Paramètres|Fermer|Démarrer|Traitées|Correct|Incorrect|Taux de réussite|Général|Total des réponses|Question|Réponses|Ajouter aux favoris|Retirer des favoris|En attente de vérification|Terminé|Résultat|Retour|Terminer l’examen|Suivant|Retour immédiat',
  kmr: 'Hîn bibe. Fam bike. Serkeve.|Ziman|Eyaleta federal|Orîjînal|hat piştrastkirin|Werger|ne berdest|Pirs|Hînbûn|Îmtîhan|Xeletî|Bijarte|Pêşketin|Mîheng|Bigire|Dest pê bike|Hat xebitandin|Rast|Çewt|Rêjeya serkeftinê|Giştî|Hemû bersiv|Pirs|Bersiv|Di bijarteyan de tomar bike|Ji bijarteyan rake|Li benda kontrolê|Qediya|Encam|Paşve|Îmtîhanê biqedîne|Pêşve|Bersiva tavilê',
  ro: 'Învață. Înțelege. Reușește.|Limbă|Land federal|Original|verificat|Traducere|indisponibil|Întrebări|Învățare|Examen|Greșeli|Favorite|Progres|Setări|Închide|Începe|Rezolvate|Corect|Greșit|Rată de reușită|General|Total răspunsuri|Întrebare|Răspunsuri|Salvează la favorite|Elimină din favorite|În curs de verificare|Finalizat|Rezultat|Înapoi|Încheie examenul|Înainte|Feedback imediat',
  bg: 'Учи. Разбери. Успей.|Език|Федерална провинция|Оригинал|проверено|Превод|недостъпно|Въпроси|Учене|Изпит|Грешки|Любими|Напредък|Настройки|Затвори|Започни|Обработени|Правилно|Грешно|Успеваемост|Общи|Общо отговори|Въпрос|Отговори|Добави в любими|Премахни от любими|Очаква проверка|Завършено|Резултат|Назад|Завърши изпита|Напред|Незабавна обратна връзка',
  it: 'Impara. Comprendi. Supera.|Lingua|Stato federato|Originale|verificato|Traduzione|non disponibile|Domande|Apprendimento|Esame|Errori|Preferiti|Progresso|Impostazioni|Chiudi|Inizia|Svolte|Corretto|Errato|Percentuale di successo|Generale|Risposte totali|Domanda|Risposte|Aggiungi ai preferiti|Rimuovi dai preferiti|In attesa di verifica|Completato|Risultato|Indietro|Termina esame|Avanti|Riscontro immediato',
  hr: 'Uči. Razumij. Položi.|Jezik|Savezna pokrajina|Izvornik|provjereno|Prijevod|nije dostupno|Pitanja|Učenje|Ispit|Pogreške|Favoriti|Napredak|Postavke|Zatvori|Pokreni|Obrađeno|Točno|Netočno|Uspješnost|Općenito|Ukupno odgovora|Pitanje|Odgovori|Spremi u favorite|Ukloni iz favorita|Čeka provjeru|Završeno|Rezultat|Natrag|Završi ispit|Dalje|Izravna povratna informacija',
  sr: 'Uči. Razumi. Položi.|Jezik|Savezna pokrajina|Original|provereno|Prevod|nije dostupno|Pitanja|Učenje|Ispit|Greške|Omiljeno|Napredak|Podešavanja|Zatvori|Pokreni|Obrađeno|Tačno|Netačno|Uspešnost|Opšte|Ukupno odgovora|Pitanje|Odgovori|Sačuvaj u omiljeno|Ukloni iz omiljenog|Čeka proveru|Završeno|Rezultat|Nazad|Završi ispit|Dalje|Neposredna povratna informacija',
  prs: 'یاد بگیر. درک کن. موفق شو.|زبان|ایالت فدرال|اصل|تأییدشده|ترجمه|در دسترس نیست|پرسش‌ها|یادگیری|امتحان|اشتباه‌ها|دلخواه‌ها|پیشرفت|تنظیمات|بستن|آغاز|کارشده|درست|نادرست|میزان موفقیت|عمومی|مجموع پاسخ‌ها|پرسش|پاسخ‌ها|ذخیره در دلخواه‌ها|حذف از دلخواه‌ها|در انتظار بررسی|تکمیل‌شده|نتیجه|بازگشت|پایان امتحان|بعدی|بازخورد فوری',
  bs: 'Uči. Razumij. Položi.|Jezik|Savezna pokrajina|Original|provjereno|Prijevod|nije dostupno|Pitanja|Učenje|Ispit|Greške|Favoriti|Napredak|Postavke|Zatvori|Pokreni|Obrađeno|Tačno|Netačno|Uspješnost|Općenito|Ukupno odgovora|Pitanje|Odgovori|Spremi u favorite|Ukloni iz favorita|Čeka provjeru|Završeno|Rezultat|Nazad|Završi ispit|Dalje|Neposredna povratna informacija',
  vi: 'Học. Hiểu. Vượt qua.|Ngôn ngữ|Bang liên bang|Bản gốc|đã xác minh|Bản dịch|không khả dụng|Câu hỏi|Học tập|Kỳ thi|Lỗi|Yêu thích|Tiến độ|Cài đặt|Đóng|Bắt đầu|Đã làm|Đúng|Sai|Tỷ lệ chính xác|Chung|Tổng số câu trả lời|Câu hỏi|Câu trả lời|Lưu vào yêu thích|Xóa khỏi yêu thích|Đang chờ kiểm tra|Hoàn thành|Kết quả|Quay lại|Kết thúc kỳ thi|Tiếp theo|Phản hồi trực tiếp',
  hu: 'Tanulj. Értsd meg. Menj át.|Nyelv|Szövetségi tartomány|Eredeti|ellenőrizve|Fordítás|nem érhető el|Kérdések|Tanulás|Vizsga|Hibák|Kedvencek|Haladás|Beállítások|Bezárás|Indítás|Feldolgozva|Helyes|Helytelen|Találati arány|Általános|Összes válasz|Kérdés|Válaszok|Mentés a kedvencekhez|Eltávolítás a kedvencekből|Ellenőrzésre vár|Befejezve|Eredmény|Vissza|Vizsga befejezése|Tovább|Azonnali visszajelzés',
  el: 'Μάθε. Κατανόησε. Πέτυχε.|Γλώσσα|Ομόσπονδο κρατίδιο|Πρωτότυπο|επαληθευμένο|Μετάφραση|μη διαθέσιμο|Ερωτήσεις|Μάθηση|Εξέταση|Λάθη|Αγαπημένα|Πρόοδος|Ρυθμίσεις|Κλείσιμο|Έναρξη|Επεξεργασμένες|Σωστό|Λάθος|Ποσοστό επιτυχίας|Γενικά|Σύνολο απαντήσεων|Ερώτηση|Απαντήσεις|Αποθήκευση στα αγαπημένα|Αφαίρεση από τα αγαπημένα|Αναμονή επαλήθευσης|Ολοκληρώθηκε|Αποτέλεσμα|Πίσω|Τερματισμός εξέτασης|Επόμενο|Άμεση ανατροφοδότηση',
};


const MESSAGES: Record<string, LiDUi> =
  Object.fromEntries(
    Object.entries(RAW).map(([language, raw]) => {
      const values = raw.split('|');

      if (values.length !== KEYS.length) {
        throw new Error(
          `Invalid LiD UI dictionary: ${language}`
        );
      }

      return [
        language,
        Object.fromEntries(
          KEYS.map((key, index) => [key, values[index]])
        ) as unknown as LiDUi,
      ];
    })
  );


export function getLidUi(language: string): LiDUi {
  return MESSAGES[language] || MESSAGES.en;
}


export function lidBilingual(
  german: string,
  translated: string,
  language: string,
): string {
  if (
    language === 'de'
    || german.toLowerCase()
      === translated.toLowerCase()
  ) {
    return german;
  }

  return `${german} · ${translated}`;
}
